import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { TRANSLATION_GROUP_TOKEN } from './tanslatation-group-token';
import { TranslationGroup } from './tanslation-group';
import { Injector } from '@angular/core';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { mergeObjs } from 'mm-web-core/common/merge-objects';


export class MmTranslateHttpLoader implements TranslateLoader {


    getTranslation(lang: string): Observable<any> {
        return of(this.groups).pipe(
            map(groups => {
                var obj = {};
                for (const g of groups) {
                    var groupName = g.groupName;
                    let translation = g.translations[lang];
                    let temp = {};
                    temp[`${groupName}`] = translation;
                    obj = {
                        ...obj,
                        ...temp
                    }
                }
                return obj;
            }),
            switchMap(obj => this.httpClient.get(`assets/i18n/${lang}.json`).pipe(
                catchError((err) => {
                    return of(obj)
                }),
                map(json => {
                    return mergeObjs(obj, json);
                })
            )),
            tap(obj => {

            })
        )

        // return this.httpClient.get(`_framework/localization/${lang}`);
    }
    httpClient: HttpClient;
    groups: TranslationGroup[];
    constructor(injector: Injector) {
        this.httpClient = injector.get(HttpClient);

        this.groups = injector.get<TranslationGroup[]>(TRANSLATION_GROUP_TOKEN);

    }

}
